import { Spinner } from 'react-bootstrap';

export const LoadingSpinner = () => (
	<Spinner
		animation='border'
		variant='primary'
		style={{
			height: '5rem',
			width: '5rem'
		}}
	/>
);

export const LoadingScreen = () => (
	<div className='full-screen-icon-container'>
		<LoadingSpinner />
	</div>
);

export const LoadingIcon = () => (
	<div className='w-100 my-5 d-flex justifx-content-center align-items-center'>
		<Spinner
			animation='border'
			variant='primary'
			style={{
				height: '5rem',
				width: '5rem'
			}}
		/>
	</div>
);
